import { render } from "./CustomFileUploader.vue?vue&type=template&id=67165fd7&scoped=true"
import script from "./CustomFileUploader.vue?vue&type=script&lang=js"
export * from "./CustomFileUploader.vue?vue&type=script&lang=js"

import "./CustomFileUploader.vue?vue&type=style&index=0&id=67165fd7&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67165fd7"]])

export default __exports__